import React from 'react'
import R from 'ramda'
import { line } from 'd3-shape'
// import styled from 'styled-components'
import moment from 'moment'
import { PredictedPath, PredictedDot } from './components'

const PredictedLayer = ({
  data,
  // minDate,
  // maxDate,
  xScale,
  yScale,
  recordDate,
  currentDate = moment()
    .startOf('month')
    .toDate(),
}) => {
  let historical = R.compose(
    R.filter(d => d.metricDate.getTime() < currentDate.getTime()),
    R.sortBy(a => a.metricDate),
    R.filter(
      d =>
        recordDate == null ||
        (d.recordDate.getTime() === recordDate.getTime() && d.valueType === 'P')
    )
  )(data)

  const future = R.compose(
    R.filter(d => d.metricDate.getTime() >= currentDate.getTime()),
    R.sortBy(a => a.metricDate),
    R.filter(
      d =>
        recordDate == null ||
        (d.recordDate.getTime() === currentDate.getTime() &&
          d.valueType === 'P')
    )
  )(data)

  historical = future.length > 0 ? [...historical, future[0]] : historical

  const futureNodes = [
    <PredictedPath
      key="furture-predted-path"
      d={line()
        .x(d => xScale(d.metricDate))
        .y(d => yScale(d.value))(future)}
    />,
    ...future.map((d, i) => (
      <PredictedDot
        key={`pred${i}`}
        cx={xScale(d.metricDate)}
        cy={yScale(d.value)}
        r={4.5}
      >
        <title>{d.value}</title>
      </PredictedDot>
    )),
  ]
  return historical.length > 1
    ? [
        <PredictedPath
          isHistorical
          key="historical-predted-path"
          d={line()
            .x(d => xScale(d.metricDate))
            .y(d => yScale(d.value))(historical)}
        />,
        ...futureNodes,

        ...historical.map((d, i) => (
          <PredictedDot
            key={`pred-his${i}`}
            cx={xScale(d.metricDate)}
            cy={yScale(d.value)}
            r={4.5}
            isHistorical
          />
        )),
      ]
    : futureNodes
}

export default PredictedLayer
